module.exports = __webpack_public_path__ + "img/mvno.4480259a.gif";